import React, { useState } from 'react';
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Menu,
  Stack,
  Typography,
} from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import { getSubjectColorNew } from '../../../helper';

// interface UserDetailCardProps {}

interface CustomCardProps {
  avatar?: string;
  name: string;
  label: string;
  subject: string;
  curriculum: string;
}

const CustomCardContent = ({
  avatar,
  name,
  label,
  subject,
  curriculum,
}: CustomCardProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Avatar src={avatar}>{name.substring(0, 1)}</Avatar>
      <Stack flexGrow={1}>
        <Stack direction="row" alignItems="center" gap={2}>
          <Typography
            fontWeight={500}
            fontSize="18px"
            className="ellipsis-text one-line"
          >
            {name}
          </Typography>
          {/* <Chip
            size="small"
            label={label}
            color="info"
            sx={{ borderRadius: '3px' }}
          /> */}
        </Stack>
        {/* <Typography
          variant="caption"
          fontSize="12px"
          className="ellipsis-text one-line"
        >
          <span
            style={{
              color: getSubjectColorNew(subject),
              fontWeight: 600,
            }}
          >
            {subject}
          </span>{' '}
          | <span style={{ fontWeight: 400 }}>{curriculum}</span>
        </Typography> */}
      </Stack>
      {/* <KeyboardArrowDownIcon /> */}
    </Stack>
  );
};

const UserDetailCard: React.FC = () => {
  // State
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Card
        elevation={0}
        sx={{ backgroundColor: '#F1F5F9', borderRadius: '70px' }}
      >
        <CardActionArea onClick={openMenu}>
          <CardContent style={{ padding: '8px' }}>
            <CustomCardContent
              name="Nipuni Arshad Test M"
              label="Primary"
              subject="Mathematics"
              curriculum="IGCSE Cambridge"
            />
          </CardContent>
        </CardActionArea>
      </Card>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '20px',
              border: '1px solid #F1F5F9',
              boxShadow: '0px 14px 40px 0px #6E9DB22E',
              padding: '16px',
              maxWidth: '340px',
            },
          },
        }}
      >
        <Stack gap={2}>
          {[
            {
              name: 'Nipuni Arshad Test M',
              label: 'Primary',
              subject: 'Mathematics',
              curriculum: 'IGCSE Cambridge',
            },
            {
              name: 'Nipuni Arshad Test M',
              label: 'Primary',
              subject: 'Mathematics',
              curriculum: 'IGCSE Cambridge',
            },
          ].map((item, index) => {
            return (
              <Card
                key={`mli-${index}`}
                elevation={0}
                sx={{
                  borderRadius: '70px',
                  '&:hover': { backgroundColor: '#F1F5F9' },
                }}
              >
                <CardActionArea>
                  <CardContent style={{ padding: '16px' }}>
                    <CustomCardContent
                      name={item.name}
                      label={item.label}
                      subject={item.subject}
                      curriculum={item.curriculum}
                    />
                  </CardContent>
                </CardActionArea>
              </Card>
            );
          })}
        </Stack>
      </Menu>
    </>
  );
};

export default UserDetailCard;
